module.exports = __webpack_public_path__ + "img/minus.3efd4695.svg";